<template>

    <page-title :title="$t('dashboard.title')"></page-title>

    <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">

        <tile :value="turnover" :title="$t('dashboard.turnover')" :icon="BanknotesIcon"></tile>
        <tile :value="amount" :title="$t('dashboard.orders')" :icon="ChartBarSquareIcon"></tile>
        <tile :value="returns" :title="$t('dashboard.returns')" :icon="ArrowPathIcon"></tile>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from "../../Layouts/AppLayout";
import Tile from "./Components/Tile";
import {ArrowPathIcon, BanknotesIcon, ChartBarSquareIcon} from "@heroicons/vue/24/outline";
import PageTitle from "../../Shared/Components/PageTitle";

export default defineComponent({
    components: {
        PageTitle,
        Tile,
        BanknotesIcon,
        ChartBarSquareIcon,
        ArrowPathIcon
    },
    props: ['turnover', 'amount', 'returns'],
    // title: "Dashboard",
    layout: AppLayout,
    setup() {
        return {
            BanknotesIcon,
            ChartBarSquareIcon,
            ArrowPathIcon
        }
    }
})
</script>
